<template>
  <li v-if="hasSpecData" :qaid="`${componentPrefix}-${componentData.title}`">
    <pdl-heading v-if="componentData.title" :level="4" size="sm" class="border-b border-gray-10 pb-25">
      {{ componentData.title }}
    </pdl-heading>
    <dl
      v-for="attributeItem in coreAttributesList"
      :key="attributeItem.label"
      :qaid="`${componentPrefix}-model-${attributeItem.label}`"
      class="flex flex-wrap py-1 text-xs items-center gap-x-2 border-b border-gray-10 last:border-b-transparent last:mb-2"
    >
      <dt class="w-32 md:w-1/6 text-gray-70 mb-0" v-html="attributeItem.label" />
      <dd v-html="attributeItem.value" />
    </dl>
  </li>
</template>

<script>
import {mapState} from 'vuex';
import {PdlHeading} from '@pedal/pdl-section-header';

export default {
  components: {
    PdlHeading,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      componentPrefix: 'product-spec',
    };
  },
  computed: {
    ...mapState('backend', ['encodedContextPath']),

    hasSpecData() {
      return !!this.coreAttributesList?.length;
    },
    coreAttributesList() {
      if (!this.componentData?.attributes) return;
      const attributes = this.componentData?.attributes?.split(',');
      const coreList = attributes
        ?.map((item) => {
          return {
            label: this.$t(`product.specification.${item}`),
            value: this.product?.specs[item],
          };
        })
        .filter((item) => item?.value);
      return coreList;
    },
  },
};
</script>
